
import { defineComponent, ref, computed, onMounted, watch, onBeforeUnmount, reactive } from 'vue'
import { useRouter } from 'vue-router'

import RoutePanel from '@/views/route/RoutePanel.vue'
import RouteLivePanel from '@/views/route/RouteLivePanel.vue'
import RouteSettings from '@/components/route/RouteSettings.vue'
import RouteMap from '@/components/route/RouteMap.vue'
import AssignDriver from '@/components/modals/AssignDriver.vue'

import { store } from '@/store'

import { setWindowTitle } from '@/api/tools'

export default defineComponent({
  name: 'Route',
  components: { RoutePanel, RouteLivePanel, RouteMap, RouteSettings, AssignDriver },
  setup() {
    const state = reactive({
      showMap: true
    })
    const loading = ref(false)
    const error = ref(false)

    const router = useRouter()
    const routeId = router.currentRoute.value.params.id as string
    
    const route = computed(() => store.route.getRoute(routeId))
    const liveState = computed(() => store.live.getLiveState(routeId))

    watch(() => route.value?.settings.name, name => {      
      setWindowTitle(name || 'Rute ' + routeId)
    }, {deep: true, immediate: true})

    onMounted(async () => {
      if (!route.value) {
        // Route does not exist locally
        loading.value = true
      }
      try {
        await store.route.initialize(routeId)
        loading.value = false
      } catch (err) {
        console.log(err)
        error.value = true
        loading.value = false
      }


      // Hide map on mobile to save map loads
      let width = document.documentElement.clientWidth
      state.showMap = width > 640
      window.addEventListener("resize", () => {
        width = document.documentElement.clientWidth
        state.showMap = width > 640
      })
    })

    onBeforeUnmount(async () => {
      store.route.saveRoute(routeId)
    })

    const minimizePlaces = ref(false)
    const optionsDropdown = ref(false)

    const user = store.user.get(state => state.user)
    const isOwner = computed(() => store.user.isOwner(routeId))

    const showAssignDriver = ref(false)

    return { store, state, route, liveState, loading, error, user, isOwner, routeId, showAssignDriver, optionsDropdown, minimizePlaces }
  },
  /*metaInfo() {
    if (this.route.exists) {
      return { 
        title: this.route.data.settings.name,
        meta: [
          { property: 'og:title', content: this.route.data.settings.name},
          { property: 'og:site_name', content: 'Tripply.dk'},
          { property: 'og:type', content: 'website'},    
          { name: 'robots', content: 'index,follow'} 
        ]
      }
    }
  }*/
})
